import { Select, Space, theme } from "antd";
import { GlobalOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useConfig } from "../../hooks/useConfig";

export const LangWidget = ({ color }) => {
    const { token } = theme.useToken();
    const { i18n } = useTranslation();
    const { changeLocale } = useConfig();

    const localeOptions = [
        { label: "English", title: "EN", value: "en" },
        { label: "Ukrainian", title: "UA", value: "uk" },
        { label: "Russian", title: "RU", value: "ru" },
    ];

    return (
        <Select
            value={i18n.resolvedLanguage}
            onChange={changeLocale}
            options={localeOptions}
            variant='borderless'
            size='large'
            popupMatchSelectWidth={false}
            suffixIcon={null}
            labelRender={(option) => (
                <Space style={{ color: color || token.colorTextBase }}>
                    <GlobalOutlined />
                    {option.title}
                </Space>
            )}
        />
    );
};
